import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem("resumatic_token");

  return token && token?.length > 0 ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
